Ext.ns('mx.data');

mx.data.MetaData = mx.data.Record.create([
    {name: 'id', type: 'string'},
    {name: 'name', type: 'string'},
    {name: 'type', type: 'string'},
    {name: 'value', type: 'string'},
    {name: 'order', type: 'int'},
    {name: 'variants', type: 'mx.data.MetaData[]'},
    {name: 'mandatory', type: 'boolean'},
    {name: 'readOnly', type: 'boolean'},
    {name: 'minValue', type: 'string'},
    {name: 'maxValue', type: 'string'},
]);
